import styled from 'styled-components';

/* Cores neutras de texto: usam --text se existir no seu tema, senão caem
   para --text-muted (que já troca no dark). Assim nunca ficam invisíveis. */
const TEXT = 'var(--text, var(--text-muted))';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 80px;
    width: 100%;
`;

export const ContainerDivs = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    color: ${TEXT};

    @media(max-width: 768px) {
        padding: 0;
    }
`;

export const ContainerStudent = styled.div`
    width: 95%;
    display: flex;
    align-items: center;
    flex-direction: column;
    max-width: 1000px;
    padding: 10px;
    gap: 15px;
    border-radius: 5px;
    background-color: var(--surface);
    border: 1px solid var(--line);
    color: ${TEXT};

    h2 {
        color: var(--teal-text);
    }

    @media(max-width: 768px) {
        padding: 5px;
    }
`;

export const DataSelected = styled.div`
    width: 100%;
`;

export const DivButton = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    //align-items: flex-start;
    gap: 20px;

    @media(max-width: 768px) {
        //align-items: flex-start;
    }
`;

export const List = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 20px;
`;

export const ListChecked = styled.div`
    border-top: 2px solid var(--green); /* Borda da lista */
    margin: 20px 0;
    width: 100%;
    padding: 10px;
    position: relative; /* Necessário para o título */

    &:before {
        content: 'Chamadas Finalizadas'; /* Texto da borda */
        position: absolute;
        top: -15px; /* Ajuste conforme necessário */
        left: 50%;
        transform: translateX(-50%); /* Centraliza o texto */
        background: var(--surface); /* Fundo para que o texto não fique atrás da borda */
        padding: 0 3px; /* Espaçamento lateral */
        font-weight: bold; /* Negrito para destaque */
        color: var(--text-muted); /* Cor do texto */

        @media (max-width: 345px)  {
            font-size: 13px; /* Smartphones pequenos */
        }
        @media (min-width: 345px) {
            font-size: 10pt; /* Smartphones pequenos */
        }

        @media (min-width: 481px) and (max-width: 768px) {
            font-size: 11pt; /* Tablets */
        }
    }
`;


export const Emp = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 30px;
    gap: 15px;
    min-width: 90%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);
    background-color: var(--bg);
    border: 1px solid var(--line);
    color: ${TEXT};

    @media(max-width: 768px) {
        width: 100%;
        gap: 2px;
        margin-bottom: 25px;
        padding: 0;
    }
`;

export const EmpEdit = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 35px;
    gap: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);
    background-color: var(--bg);
    border: 1px solid var(--line);

    @media(max-width: 768px) {
        width: 100%;
        gap: 2px;
        padding: 0;
    }
`;

export const DivInfo = styled.div`
    background-color: var(--surface);
    color: ${TEXT};
    width: 90%;
    max-width: 600px;
    padding: 20px;
    padding-top: 40px;
    padding-bottom: 40px;
    border-radius: 5px;
    border: 1px solid var(--line);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);

    h3 {
        text-align: center;
        padding-bottom: 30px;
        color: var(--teal-text);
    }
`;

export const DivInfoDate = styled.div`
    background-color: var(--surface);
    color: ${TEXT};
    width: 90%;
    max-width: 600px;
    padding: 15px;
    padding-top: 40px;
    padding-bottom: 40px;
    gap: 30px;
    border-radius: 5px;
    border: 1px solid var(--line);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);

    h3 {
        text-align: center;
        padding-bottom: 30px;
        color: var(--teal-text);
    }
`;

export const Span = styled.button`
    border: none;
    background: transparent;
    font-size: 16px;
    color: ${TEXT};

    @media (max-width: 375px)  {
        width: 90%;
      font-size: 9pt; /* Smartphones pequenos */
      padding: 0;
    }
    @media (min-width: 375px) and (max-width: 768px) {
        width: 90%;
      font-size: 10pt; /* Smartphones pequenos */
      padding: 0;
    }
`;

export const SpanChecked = styled.button`
    display: flex;
    align-items: center;
    gap: 20px;
    border: none;
    background: transparent;
    font-size: 16px;
    color: ${TEXT};

    @media (max-width: 375px)  {
      font-size: 9pt; /* Smartphones pequenos */
      padding: 0;
    }
    @media (min-width: 375px) and (max-width: 768px) {
      font-size: 10pt; /* Smartphones pequenos */
      padding: 0;
    }
`;

export const Btt02 = styled.button`
    padding: 10px;
    background-color: var(--teal);
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: filter 0.2s ease, transform 0.12s ease;

    &:hover {
        filter: brightness(1.12);
    }
    &:active { transform: translateY(1px); }
    &:disabled { opacity: .5; cursor: not-allowed; filter: none; }

    @media (max-width: 375px)  {
      font-size: 8pt; /* Smartphones pequenos */
      padding: 6px;
    }
    @media (min-width: 375px) and (max-width: 768px) {
      font-size: 9pt; /* Smartphones pequenos */
      padding: 7px;
    }

    @media(min-width: 600px) {
        padding: 10px;
    }
`;

export const SelectorContainer = styled.div`
    margin-bottom: 20px;
`;

export const EditContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    color: ${TEXT};

    h3 {
        text-align: center;
        color: var(--teal-text);
    }

    select {
        width: 80%;
        max-width: 400px;
        padding: 10px;
        font-size: 16px;
        border: 1px solid var(--line);
        border-radius: 5px;
        background: var(--surface);
        color: ${TEXT};

        option { background: var(--surface); color: ${TEXT}; }
    }
`;

// Componente para a lista de chamada
export const AttendanceList = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 10px;
    margin-top: 20px;
`;

export const AttendanceItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-radius: 5px;
    background-color: ${props => (props.checked
        ? 'color-mix(in srgb, var(--green) 16%, transparent)'
        : 'color-mix(in srgb, var(--coral) 16%, transparent)')};
    transition: background-color 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);
    cursor: pointer;

    &:hover {
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    }
`;

export const AttendanceButton = styled.button`
    padding: 5px 10px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: filter 0.2s ease;
    color: white;

    &.present {
        background-color: var(--green); /* Verde para presença */
        &:hover { filter: brightness(1.12); }
    }

    &.absent {
        background-color: var(--coral); /* Vermelho para ausência */
        &:hover { filter: brightness(1.12); }
    }
`;

export const BoxButton = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;

    .nota {
      display: flex;
    }
    .Presence {
        display: flex;
        border: 2px solid var(--green); /* Verde forte */
        box-shadow: 0 0 5px color-mix(in srgb, var(--green) 50%, transparent);
        padding: 5px;
        border-radius: 8px;
    }
    .Absence {
        display: flex;
        border: 2px solid var(--coral); /* Vermelho forte */
        box-shadow: 0 0 5px color-mix(in srgb, var(--coral) 50%, transparent);
        padding: 5px;
        border-radius: 8px;
    }
    .justifi {
      display: flex;
      border: 2px solid #8b5cf6; /* Roxo */
        box-shadow: 0 0 5px rgba(139, 92, 246, 0.5);
        padding: 3px;
        border-radius: 8px;
    }
    .not {
        display: flex;
        border: 2px solid var(--line); /* Neutro, visível nos dois temas */
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.35);
        padding: 3px;
        border-radius: 8px;
    }
    .check {
      display: flex;
      gap: 10px;
    }

    label {
        color: ${TEXT};

        @media (min-width: 1024px) {
            font-size: 17px;

            input {
                width: 20px;
                height: 20px;
            }
        }
    }


    @media(max-width: 768px) {
        gap: 10px;
    }
`;

export const BoxButtonEdit = styled.div`
    display: flex;
    gap: 100px;
    justify-content: space-between;
`;

export const BoxButtonStatus = styled.div`
    display: flex;
    padding: 20px;
    gap: 20px;
`;

export const ToGoBack = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 20px;
  cursor: pointer;
`;

export const SignMessageButtonText = styled.span`
  color: var(--text-muted);
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const SignMessageButtonTextBold = styled.span`
  color: var(--teal-text);
  font-weight: bold;
  margin-left: 5px;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const SkeletonItem = styled.div`
    width: 100%;
    height: 60px;
    border-radius: 10px;
    margin-bottom: 10px;

    background: linear-gradient(
        90deg,
        var(--bg) 25%,
        color-mix(in srgb, var(--bg) 55%, var(--line)) 50%,
        var(--bg) 75%
    );

    background-size: 200% 100%;
    animation: shimmer 1.2s infinite;

    @keyframes shimmer {
        0% {
            background-position: 200% 0;
        }
        100% {
            background-position: -200% 0;
        }
    }
`;